export const F1_CONSTRUCTORS = [
  { name: 'McLaren',        color: '#FF8000', logo: '🟠' },
  { name: 'Ferrari',        color: '#E8002D', logo: '🔴' },
  { name: 'Red Bull Racing',color: '#3671C6', logo: '🔵' },
  { name: 'Mercedes',       color: '#27F4D2', logo: '🩵' },
  { name: 'Aston Martin',   color: '#229971', logo: '🟢' },
  { name: 'Williams',       color: '#64C4FF', logo: '🩵' },
  { name: 'Alpine',         color: '#FF87BC', logo: '🩷' },
  { name: 'Racing Bulls',   color: '#6692FF', logo: '🔵' },
  { name: 'Haas',           color: '#B6BABD', logo: '⚪' },
  { name: 'Audi',           color: '#52E252', logo: '🟢' },
  { name: 'Cadillac',       color: '#CC0000', logo: '🔴' },
];
